module.exports = __webpack_public_path__ + "img/topdown.3580a84.jpg";